// import Players from '@/assets/json/ranking-players.json'
import General from '@/assets/json/general-config.json'
import Players from '@/assets/json/ranking-players.json'
import Pkers from '@/assets/json/ranking-pkers.json'
import Guild from '@/assets/json/ranking-guild.json'
import GuildDetail from '@/assets/json/guilds.json'
import DashChar from '@/assets/json/dashboard-character.json'
import DashActiv from '@/assets/json/dashboard-activity.json'
import Credits from '@/assets/json/credits.json'
import WebBank from '@/assets/json/webank.json'

const Getters = {
    GetJson() {
        return function(param) {
            switch (param) {
                case 'general': 
                    return General
                case 'players': 
                    return Players
                case 'pkers': 
                    return Pkers
                case 'guild': 
                    return Guild
                case 'guild-detail':
                    return GuildDetail
                case 'dashboard-characters':
                    return DashChar
                case 'dashboard-activity':
                    return DashActiv
                case 'credits':
                    return Credits
                case 'webank':
                    return WebBank
                default:
                    return General       
            }
        }
    },
    GetUser(state) {
        return state.auth.user.user
    },
    GetToken(state) {
        return state.auth.user.token
    },
    isLoggedIn(state) {
        return state.auth.status.loggedIn
    },
    GetApiPath(state) {
        return state.api.path
    },
    GetLoader(state) {
        return state.loader
    },
    GetPage(state) {
        return state.page
    },
    GetDashboardData(state) {
        return state.dashboard
    },
    GetMobileBrowser () {
        var check = false;
        (function(a){
          if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },
    GetPageMenu(state) {
        return state.page.menu
    },
    GetMessages(state) {
        return state.messages
    },
    GetCharacterBreed(state) {
        return function(val) {
            return state.character.breed['char'+val]
        }
    },
    getCharacterImage(state) {
        return function(pj) {
            var character = state.character.initial['char'+pj]
            var path = `${state.baseUrl}images/characters/${character}-min.png`
            return path
        }
    },
    resetConditions(state) {
        return state.reset
    },
    CheckCookies(state) {
        return state.cookies
    },
    GetServerInfo(state) {
        return state.server
    },
    GetCommands(state) {
        return state.commands
    },
    GetMemberStatus(state) {
        return state.memberStatus
    },
    GetEndpoints(state) {
        return state.endpoints
    },
    GetTop3Player(state) {
        return state.shortRank.player
    },
    GetTop3Guild(state) {
        return state.shortRank.guild
    },
    GetTop3Pker(state) {
        return state.shortRank.pker
    },
    GetNews(state){
        return state.news
    },
    numberWithCommas() {
        return function(x) {
            var parts = x.toString().split(".");
            parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
            return parts.join(",");
        }
    },
    costs(state) {
        return state.cost
    },
    dateTimeLeft() {
        return function(date) {
            var today = new Date()
            // get total seconds between the times
            var delta = Math.abs(date - today) / 1000;

            // calculate (and subtract) whole days
            var days = Math.floor(delta / 86400);
            delta -= days * 86400;

            // calculate (and subtract) whole hours
            var hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;

            // calculate (and subtract) whole minutes
            var minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;

            // what's left is seconds
            //var seconds = delta % 60;  // in theory the modulus is not required
            return {
                days: days,
                hours: hours,
                minutes: minutes
            }
        }
    },
    addDaystoDate() {
        return function(date, days) {
            var newdate = new Date(date);
        
            newdate.setDate(newdate.getDate() + days);
            return newdate
        }
    },
    dateToTimestamp() {
        return function(date) {
            return Math.round(date.getTime()/1000)
        }
    },
    GetVipData(state) {
        return state.vip
    },
    GetDateTimeFormat() {
        return function(coming_date){
          var date = new Date(coming_date)
          return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        }
    },
    GetPlayersOnlineModal(state) {
        return state.modals.online
    },
    GetMapName(state) {
        return function(mapNumber) {
            return state.maps[mapNumber]
        }
    }
}

export default Getters;